(() => {
  const scrollToBuy = (root, event) => {
    const target = root.querySelector('#buy');
    if (!target) return;
    event.preventDefault();
    const headerOffset = 72;
    const targetRect = target.getBoundingClientRect();
    const viewportHeight = window.innerHeight;
    const targetTop =
      headerOffset +
      Math.max(0, (viewportHeight - headerOffset - targetRect.height) / 2);
    const documentHeight = Math.max(
      document.documentElement.scrollHeight,
      document.body?.scrollHeight || 0,
    );
    const maxScroll = Math.max(0, documentHeight - viewportHeight);
    const destination = Math.min(
      maxScroll,
      Math.max(0, window.scrollY + targetRect.top - targetTop),
    );
    window.scrollTo({ top: destination, behavior: 'smooth' });
    window.history.replaceState(
      null,
      '',
      window.location.pathname + window.location.search + '#buy',
    );
  };
  const init = (root) => {
    root.querySelectorAll('[data-dgh-scroll-to-buy]').forEach((trigger) => {
      trigger.addEventListener('click', (event) => scrollToBuy(root, event));
    });
    const purchase = root.querySelector('[data-dgh-native-purchase]');
    if (!purchase) return;
    const form = purchase.querySelector('form');
    const variantInput = purchase.querySelector('[data-dgh-variant]');
    const sellingPlanInput = purchase.querySelector('[data-dgh-selling-plan]');
    const addButton = purchase.querySelector('[data-dgh-add]');
    const buyOnce = purchase.querySelector('[data-dgh-buy-once]');
    const choices = [...purchase.querySelectorAll('[data-dgh-plan]')];
    if (!form || !variantInput || !sellingPlanInput || !addButton) return;

    const announceChange = (input) => {
      input.dispatchEvent(new Event('change', { bubbles: true }));
    };
    const select = (choice) => {
      choices.forEach((candidate) => {
        candidate.setAttribute(
          'aria-checked',
          String(candidate === choice),
        );
      });
      variantInput.value = choice.dataset.variantId;
      sellingPlanInput.disabled = false;
      sellingPlanInput.value = choice.dataset.sellingPlanId;
      addButton.disabled = choice.dataset.available !== 'true';
      announceChange(variantInput);
      announceChange(sellingPlanInput);
    };
    choices.forEach((choice) => {
      choice.addEventListener('click', () => select(choice));
    });
    if (buyOnce) {
      buyOnce.addEventListener('click', () => {
        choices.forEach((choice) =>
          choice.setAttribute('aria-checked', 'false'),
        );
        variantInput.value = buyOnce.dataset.variantId;
        sellingPlanInput.disabled = true;
        addButton.disabled = buyOnce.dataset.available !== 'true';
        announceChange(variantInput);
        form.requestSubmit(addButton);
      });
    }
    const initial =
      choices.find((choice) => choice.getAttribute('aria-checked') === 'true') ||
      choices[0];
    if (initial) select(initial);
  };
  const start = () =>
    document
      .querySelectorAll('[data-daily-gut-health]')
      .forEach((root) => init(root));
  document.addEventListener(
    'click',
    (event) => {
      const trigger =
        event.target instanceof Element
          ? event.target.closest('a.try-now.btn')
          : null;
      if (
        !trigger ||
        trigger.textContent.trim().toUpperCase() !== 'TRY IT NOW'
      ) {
        return;
      }
      const root = document.querySelector('[data-daily-gut-health]');
      if (!root || root.contains(trigger)) return;
      event.stopPropagation();
      scrollToBuy(root, event);
    },
    true,
  );
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();